export enum HelpCenterIconType {
  Error,
  Warning,
  Help,
  Chat,
  Tools,
}
